import { z } from 'zod';

export const consentCodePrefixSchema = z.object({
  prefix: z
    .string()
    .refine(
      (value) => value === '' || /^[A-Z0-9]{1,6}$/.test(value),
      'Prefiks może zawierać tylko wielkie litery i cyfry (max 6 znaków)',
    ),
});

export type ConsentCodePrefixFormData = z.infer<typeof consentCodePrefixSchema>;
